import api from "@/services/api.js";

let initialState = {
  event: null,
  events: [],
  selected: ""
};

export default {
  state: {
    ...initialState
  },
  mutations: {
    SET_EVENT(state, payload) {
      state.event = payload;
    },
    SET_EVENTS(state, payload) {
      state.events = payload;
    },
    SET_SELECTED(state, payload) {
      state.selected = payload;
    }
  },
  actions: {
    async loadEvent({ commit }, eventId) {
      commit("SET_SELECTED", eventId);
      commit("SET_EVENT", ""); // trigger reactivity
      const event = await api.getEvent(eventId);
      commit("SET_EVENT", event);
    },
    async loadEvents({ commit }) {
      const events = await api.getEvents();
      commit("SET_EVENTS", events);
    },
    async saveEvent({ state, dispatch, commit }, payload) {
      await api.updateEvent(state.event._id, payload);
      dispatch("loadEvents");
      commit("SET_MESSAGE", { content: "Settings Saved!", color: "success" });
    },
    async createEvent({ commit }, payload) {
      const event = api.createEvent(payload);
      localStorage.setItem("agmify-admin-event", event._id);
      window.location.href = "/admin/settings";
      commit("SET_MESSAGE", { content: "Event Saved!", color: "success" });
    },
    async archiveEvent({ dispatch, state, commit }) {
      await api.deleteEvent(state.event._id);
      await dispatch("loadEvents");
      commit("SET_EVENT", null);
    },
    async deleteEvent({ dispatch }, id) {
      await api.deleteArchivedEvent(id);
      await dispatch("loadEvents");
    },
    async restoreEvent({ dispatch }, id) {
      await api.restoreArchivedEvent(id);
      await dispatch("loadEvents");
    }
  }
};
